import { useQuery } from "@tanstack/react-query";
import apiClient from "./apiClient";

/**
 * Fetch active photos from the backend
 * Used for displaying photos in gallery and home page
 */
export const useGetPhotos = () => {
  return useQuery({
    queryKey: ["photos"],
    queryFn: async () => {
      const response = await apiClient.get("/api/PhotoLibrary/active");
      return response.data;
    },
    staleTime: 1000 * 60 * 5, // 5-minute cache (reduced from 30 to show likes updates faster)
  });
};

/**
 * Fetch all photos with pagination
 * Useful for gallery pages with more granular control
 */
export const useGetAllPhotos = (pageNumber = 1, pageSize = 50) => {
  return useQuery({
    queryKey: ["photos", pageNumber, pageSize],
    queryFn: async () => {
      const response = await apiClient.get("/api/PhotoLibrary", {
        params: { pageNumber, pageSize },
      });
      return response.data;
    },
    staleTime: 1000 * 60 * 5, // 5-minute cache
  });
};

/**
 * Fetch a specific photo by ID
 */
export const useGetPhotoById = (photoId) => {
  return useQuery({
    queryKey: ["photo", photoId],
    queryFn: async () => {
      const response = await apiClient.get(`/api/PhotoLibrary/${photoId}`);
      return response.data;
    },
    staleTime: 1000 * 60 * 5, // 5-minute cache
    enabled: !!photoId, // Only run query if photoId exists
  });
};
